// extracted by mini-css-extract-plugin
export default {"container":"Routes_container__c38BX"};